var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"cwx-icon",class:[_vm.classesForIcon,
           _vm.fixedWidth ? 'cwx-icon-fixed-width' : null,
           _vm.link ? 'cwx-icon--link' : null,
           _vm.disabled ? 'cwx-icon--disabled' : null],style:({ color: _vm.color }),attrs:{"aria-hidden":"true"}},[_vm._t("takeClassesForIcon",[_vm._v(_vm._s(_vm.takeClassesForIcon()))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }